import GroupM from './groupm/logo.png'

export const partnerLogos = {
  mspark: GroupM,
}
